import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { PropsWithChildren, useState } from 'react';

interface IButtonWithSpinnerProps extends PropsWithChildren {
  // eslint-disable-next-line react/require-default-props
  buttonProps?: ButtonProps;
  /**
   * When the button should be disabled
   * By default it will be disabled when the promise is running
   */
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
  /**
   * A handler for click action, which should return a promise
   * @returns Promise
   */
  onClick: () => Promise<unknown>;

  customWidth?: string;
}

export default function ButtonWithSpinner({
  buttonProps = {},
  disabled = false,
  onClick,
  children,
  customWidth = ''
}: IButtonWithSpinnerProps) {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Button
      sx={customWidth ? { width: customWidth, ml: 1 } : { ml: 1 }}
      variant={isLoading ? 'outlined' : 'contained'}
      disabled={disabled || isLoading}
      onClick={() => {
        setIsLoading(true);
        onClick()
          .then(() => {
            setIsLoading(false);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }}
      {...buttonProps}
    >
      <span style={{ marginRight: '2px' }}>{children}</span>
      {isLoading && (
        <CircularProgress
          style={{
            width: ' 15px',
            height: '15px',
            marginRight: '8px'
          }}
        />
      )}
    </Button>
  );
}
